import { useState, useEffect } from 'react';

// 🟢 Ensure this path matches where your updated feedbackApi is located
import { feedbackAPI } from '../../api/expertReviewApis/feedbackApi'; 

export function useExpertReviews(expertCode: string | undefined) {
  // State for the reviews array
  const [reviews, setReviews] = useState<any[]>([]);
  // State for the aggregated math (defaulting to 5 stars, 0 reviews)
  const [ratingStats, setRatingStats] = useState({ rating: 5.0, reviewsCount: 0 });
  // Loading state so the UI can show a skeleton/spinner
  const [isLoadingReviews, setIsLoadingReviews] = useState(true);
  // Optional error state in case the API goes down
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // If there's no expert code yet, stop here.
    if (!expertCode) {
      setIsLoadingReviews(false);
      return;
    }

    const fetchReviews = async () => {
      setIsLoadingReviews(true);
      setError(null);
      
      try {
        const data = await feedbackAPI.getExpertReviews(expertCode);
        
        // 🟢 Safely update state with backend data
        setReviews(data.reviews || []);
        setRatingStats(data.stats || { rating: 5.0, reviewsCount: 0 });
        
      } catch (err) {
        console.error("Failed to fetch expert reviews:", err);
        setError("Could not load reviews.");
        // Optional: show a toast, though silently failing on a public profile might be preferred UI UX
        // toast.error("Failed to load expert reviews."); 
      } finally {
        setIsLoadingReviews(false);
      }
    };

    fetchReviews();
  }, [expertCode]); // Re-run if the expertCode changes (e.g., navigating to a different profile)

  return { 
    reviews, 
    ratingStats, 
    isLoadingReviews, 
    error 
  };
}